<!-- 新闻查询 -->
<template> 
<div class="detail-wrap"> 
    <PageBack :title="title" />
    <el-form :model="searchForm" ref="searchForm" :inline="true"  label-width="100px">               
        <el-form-item label="时间" prop="dateRange">
            <el-date-picker                        
                v-model="searchForm.dateRange"
                type="daterange"
                value-format="yyyy-MM-dd"
                range-separator="-"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                @change="selectDate"
                />
        </el-form-item> 
        <el-form-item label="状态" prop="status">
            <el-radio-group v-model="searchForm.status">               
                <el-radio label="" >已发布</el-radio>
                <el-radio label="2">未发布</el-radio>                
            </el-radio-group>
        </el-form-item>
        <el-form-item>
            <el-button type="primary" @click="searchQuery('searchForm')">查询</el-button>
            <el-button @click="resetForm('searchForm')">重置</el-button>
        </el-form-item>       
    </el-form>
    <el-table border :data="tableData" style="width: 100%;" v-loading="loading">
    <el-table-column  type="index" width="100" label="序号" align="center"/>
    <el-table-column  prop="title"  label="新闻标题"  >
        <template slot-scope="scope">
            <router-link :to="{path: 'newsDetail', query: { id: scope.row.serial,status: scope.row.status }}" 
                :class="scope.row.status==='2'? 'red': 'green'">{{ scope.row.title }}</router-link>
    </template>
    </el-table-column>    
    <el-table-column  prop="date"  label="发布时间"   width="180"/>
    <el-table-column  prop="statusValue"  label="状态"  width="100">
        <template  slot-scope="scope">
            <el-tag :type="limitStatus(scope.row.status)">{{ scope.row.statusValue }}</el-tag>
        </template>
    </el-table-column>
    <el-table-column  fixed="right" label="操作"  width="300">
        <template slot-scope="scope" v-if="userId === scope.row.userId">                       
            <el-button @click="handleUpdate(scope.row,0)" 
                type="text" icon="el-icon-edit" size="small">编辑</el-button>      
            <el-button @click="handleSubmit(scope.row)" v-if="scope.row.status === '2'"
            type="text" icon="el-icon-edit" size="small">正式发布</el-button>             
            <el-button @click="handleDelete(scope.row)" type="text" icon="el-icon-delete" size="small">删除</el-button>
            <el-button @click="handleCopy(scope.row.newsLink)" v-if="scope.row.status === '2'"
                type="text" icon="el-icon-edit" size="small" id="btn" 
                data-clipboard-action="copy" data-clipboard-target="#btn" >复制链接</el-button>    
        </template>                   
    </el-table-column>
    </el-table>
    <pagination
        style="text-align:right"
        v-show="total > 10"
        :total="total"
        :page.sync="queryParams.page"
        :limit.sync="queryParams.pagesize"
        @pagination="initData"
    />   
</div>
</template>
    
<script>
import pagination  from '@/components/Pagination'
import PageBack from '@/components/PageHeader'
export default {
    components:{
        pagination,
        PageBack
    },
    data() {
        return {
            loading: false,
            searchForm:{
                dateRange: [],
                status: '',
            },
            startDate: 0,
            endDate: 0,
            queryParams: {
                page: 1,
                pagesize: 10
            },
            tableData: [], 
            total: 0,
            statusOption: [
                {label:'已发布',value: ''},
                {label:'待发布',value: '2'},
            ]
        }   
    },
    created() {
       
    },
    mounted() {
        this.searchForm.status = this.$route.query.status || ''
        setTimeout(()=>{
            this.initData()
        },10)       
    },
    computed:{
        title(){
            return this.$route.meta.title
        },
        userId(){
            return localStorage.getItem('playerNo')
        },
        adminRoles(){
            let value = localStorage.getItem('roles')
            if(value === '管理员' || value === '掼蛋协会' || value === '裁判' || value === '掼蛋俱乐部'){
                return true
            }else{
                return false
            }     
        }    
    },
    methods: {
        // 已发布新闻
        initData(){
            let params = {
                opcode: this.$code.NewsQuery,
                i_serial: 0,
                v_title: '',    
                c_status: this.searchForm.status,           
                start_date: this.startDate,
                end_date: this.endDate,
                pagesize: this.queryParams.pagesize,
                page: this.queryParams.page,
            }
            this.loading = true
            this.$api._requestAPI(params).then(res =>{
                if (res.IsSuccess) {
                    let result = res.Data.DataTable
                    this.total = res.Data.SumCount
                    this.tableData = result.map((item,index)=>{
                        let startDate = this.$help.formatDate(item['日期'])
                        let startTime = this.$help.formatTime(item['时间'])                        
                        return{
                            serial: item['序号'],
                            title: item['标题'],    
                            des: item['详情'],
                            status: item['状态'],   
                            statusValue: item['状态']==='2'?'未发布':'已发布',                     
                            date: startDate +' '+ startTime,
                            userId: item['发布人账号'],
                            newsLink: window.location.origin +'/#/detail?id='+item['序号'] +'&status=2'
                        }
                    }) 
                    this.loading = false
                }
            })
        },
        handleDelete(row){
          this.$confirm('确定删除这条新闻吗?','提示').then(()=>{
            this.deleteConfirm(row)
          }).catch(err=>{
            console.log(err)
          })
        },
        deleteConfirm(row){
            let params = {
                opcode: this.$code.AddUpdateNews,
                i_serial: row.serial,
                v_title: '',
                v_introduction: '',
                v_details: '',
                v_image: '',
                c_status: row.status,
                i_flag: 3,
                v_flag: 1,                
            }
            this.$api.requestAPI(params).then(res=>{
                if(res.IsSuccess){
                    this.$message.success('删除成功')
                    this.initData()             
                }else{
                    this.$message.success(res.Message)
                }
            })
        },
        handleUpdate(row,value){
            this.$router.push({
                path: 'newsPage',
                query: {
                    id: row.serial,
                    status: row.status                   
                }
            })
        },          
        selectDate(d){
            if(d !== null){
                this.startDate = d[0].replace(/\-/g,'')
                this.endDate = d[1].replace(/\-/g,'')
            }else{
                this.startDate = 0
                this.endDate = 0
            }            
        },
        searchQuery() {
            this.initData()
        },
        resetForm(formName) {
            this.startDate = 0
            this.endDate = 0
            this.$refs[formName].resetFields();
        },
        handleSubmit(row){
            let params = {
                opcode: this.$code.AddUpdateNews,
                i_serial: row.serial,
                v_title: row.title,
                v_introduction: '',
                v_details: row.des,
                v_image: '',
                c_status: 0,
                i_flag: 2,
                v_flag: 1,               
            }
            this.$api.requestAPI(params).then(res=>{
                if(res.IsSuccess){                                     
                    this.$message.success('新闻发布成功!')     
                    this.initData()              
                }else{
                    this.$message.success('新闻发布失败!')
                }
            })
        },
        limitStatus(value){
            if(value ==='2'){
                return 'danger'
            }else if(value==='0'){
                return 'success'
            }
        },
        handleCopy(url){
            var input = document.createElement("input"); // 创建input对象
            input.value = url; // 设置复制内容
            document.body.appendChild(input); // 添加临时实例
            input.select(); // 选择实例内容
            document.execCommand("Copy"); // 执行复制
            document.body.removeChild(input); // 删除临时实例
            this.$message.success('复制链接成功：'+ input.value)
        }
    }
}
</script>
<style lang='scss' scoped>
@import '@/assets/css/style.scss';
.detail-wrap{
    margin-top: 10px;
}
.red{
    color: red;
    text-decoration: underline;
}
.green{
    color: #67c23a;
    text-decoration: underline;
}
</style>


// WEBPACK FOOTER //
// src/views/news/newsQuery.vue